module.exports = __webpack_public_path__ + "img/big_11B05_orange.0c0485fa.png";